let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("95SvH")).then(() => parcelRequire('cakt5'));